// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2maNr","info":"Note_info__1Sbvi","note":"Note_note__1561s","actions":"Note_actions__abl42"};